import React, { useState, useRef } from 'react';
import LanguageCurrencyPickerProps from './props';
import LanguageCurrencyModal from './components/LanguageCurrencyModal/LanguageCurrencyModal';
import LanguageCurrencyToggle from './components/LanguageCurrencyToggle/LanguageCurrencyToggle';
import Picker from './components/Picker/Picker';
import { LanguageCurrencyModalHandle } from './components/LanguageCurrencyModal/props';

import './styles.scss';

function LanguageCurrencyPicker(props: LanguageCurrencyPickerProps) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  const modalRef = useRef<LanguageCurrencyModalHandle>(null);

  const handleToggle = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsOpen(true);
  };

  const handleModalClose = () => {
    setIsOpen(false);
  }

  const handleButtonClick = (
    e: React.MouseEvent<HTMLButtonElement>,
    state: { language: string; currency: string }
  ) => {
    e.preventDefault();
    modalRef?.current?.closeModal();
    props.buttonOnClick(e, state);
  };

  return (
    <div
      className="language-currency-picker"
      data-e2e="language-currency-picker"
      ref={containerRef}
    >
      <LanguageCurrencyToggle
        flagCountryUrl={props.flagCountryUrl}
        countryName={props.countryName}
        languageName={props.languageName}
        currencyName={props.currencyName}
        handleToggle={handleToggle}
        hideCurrency={props.hideCurrency || false}
      />
      <LanguageCurrencyModal
        {...props}
        isOpen={isOpen}
        onClose={handleModalClose}
        ref={modalRef}
      >
        <Picker
          {...props}
          buttonOnClick={handleButtonClick}
          buttonText={props.buttonText}
          title={props.title}
          hideCurrency={props.hideCurrency || false}
        />
      </LanguageCurrencyModal>
    </div>
  );
}

export default React.memo(LanguageCurrencyPicker);
